import React from "react";
import { useTranslation } from "react-i18next";

import { GRAY_500 } from "../../../../../constant/colors";
import { getExpressEnrollmentMapping } from "../../configurations";
import { fontWeights, sizes } from "../../../../../constant/styles";
import { EnrollFailureHeader, EnrollFailureSupportFooter, TextStyled } from "./EnrollFailureShared";

export const EnrollGeneralFailure = ({ error }) => {
  const { t } = useTranslation();
  const expressEnrollMapping = getExpressEnrollmentMapping();
  const errorText = expressEnrollMapping?.getErrorText?.(t, error);

  return (
    <>
      <EnrollFailureHeader error={error} />
      <div style={{ fontWeight: fontWeights.regular, fontSize: sizes.medium_large, color: GRAY_500 }}>
        {errorText || t("patientApplications.enroll.enroll_result.please_try_to_resubmit_the_application")}
      </div>
      <EnrollFailureSupportFooter>
        <TextStyled>{t("patientApplications.enroll.enroll_result.contact_support_with_error")}</TextStyled>
      </EnrollFailureSupportFooter>
    </>
  );
};
